import {object, string} from 'yup'

export const danceCollectionSchema = object({
    type: string().required('required'),
    nameEng: string().required('required'),
    nameHeb: string().required('required'),
})
